import { FC, useEffect, useState } from "react";
import "./AutofillCountdown.css";

type Props = {
  lastOrderedAt: string | null | undefined;
};

export const AutofillCountdown: FC<Props> = ({ lastOrderedAt }) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!lastOrderedAt) {
      setTimeLeft(null);
      return;
    }

    const updateCountdown = () => {
      const orderTime = new Date(parseFloat(lastOrderedAt)).getTime();

      if (isNaN(orderTime)) {        
        setTimeLeft(null);
        return;
      }
      
      const now = new Date().getTime();
      const elapsed = now - orderTime;
      const fifteenMinutes = 15 * 60 * 1000;
      const remaining = fifteenMinutes - elapsed;

      if (remaining <= 0) {
        setTimeLeft(null);
      } else {
        setTimeLeft(remaining);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [lastOrderedAt]);

  if (timeLeft === null) {
    return null;
  }

  const minutes = Math.floor(timeLeft / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return (
    <div className="AutofillCountdown">
      Autofyld af kurv starter igen om {minutes}:{seconds.toString().padStart(2, '0')}
    </div>
  );
};